import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { HelpCenterSettingsArticlesAppEntryPoint as main } from '@atlassian/jira-spa-apps-help-center-settings-articles/entrypoint.tsx';

export const helpCenterSettingArticlesAppPageEntryPoint = createPageEntryPoint({
	main,
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});
